import { render } from "./Oneorder.vue?vue&type=template&id=9ada8868&scoped=true"
import script from "./Oneorder.vue?vue&type=script&lang=js"
export * from "./Oneorder.vue?vue&type=script&lang=js"

import "./Oneorder.vue?vue&type=style&index=0&id=9ada8868&lang=css"
import "./Oneorder.vue?vue&type=style&index=1&id=9ada8868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ada8868"]])

export default __exports__